module.exports = __webpack_public_path__ + "img/image-2@2x.2c2b10b7.png";